import { render, staticRenderFns } from "./TsgDictionary.vue?vue&type=template&id=b20cad86&scoped=true&"
import script from "./TsgDictionary.vue?vue&type=script&lang=js&"
export * from "./TsgDictionary.vue?vue&type=script&lang=js&"
import style0 from "./TsgDictionary.vue?vue&type=style&index=0&id=b20cad86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20cad86",
  null
  
)

export default component.exports